import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import { useCheckAuth } from "../api/effects/mutations/checkAuth";
import UserState from "../recoil/UserState";
import { eraseCookie, getCookie } from "../utils/cookies";

export default function Layout() {
  const token = getCookie("token");

  const recoilValue = useRecoilValue(UserState);
  const setRecoil = useSetRecoilState(UserState);
  const removeRecoil = useResetRecoilState(UserState);

  const navigate = useNavigate();

  const eraseRecoil = async () => {
    removeRecoil();
  };

  const eraseAuthCookie = async () => {
    eraseCookie("token");
  };
  const { mutateAsync: checkAuth } = useCheckAuth({
    onSuccess(data) {
      setRecoil(data);
    },
    onError() {
      eraseAuthCookie()
        .then(eraseRecoil)
        .then(() => navigate("/", { replace: true }));
      alert("Session Timed Out");
    },
  });

  useEffect(() => {
    if (token !== null && recoilValue === null) checkAuth({});
  }, []);

  return (
    <main
      style={{
        backgroundColor: "#F9FDFF",
        minHeight: "100vh",
        height: "100%",
      }}
    >
      <Outlet />
    </main>
  );
}
